var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticStyle:{"top":"16px"},attrs:{"color":"primary","absolute":"","dark":"","fab":"","top":"","right":""},on:{"click":function($event){return _vm.$emit('onClick')}}},[_c('v-icon',{staticStyle:{"padding":"16px"},domProps:{"textContent":_vm._s(_vm.icon)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }